import { GetOneInspectionInDto, GetLastInspectionOutDto } from '../../../types/inspection.dto'

export const GET_LAST_INSPECTION = 'GET_LAST_INSPECTION'
export const GET_LAST_INSPECTION_SUCCESS = 'GET_LAST_INSPECTION_SUCCESS'
export const GET_LAST_INSPECTION_ERROR = 'GET_LAST_INSPECTION_ERROR'
export const RESET_GET_LAST_INSPECTION = 'RESET_GET_LAST_INSPECTION'

export interface GetLastInspection {
  type: typeof GET_LAST_INSPECTION
  payload: GetLastInspectionOutDto
}

export interface GetLastInspectionSuccess {
  type: typeof GET_LAST_INSPECTION_SUCCESS
  payload: GetOneInspectionInDto
}

export interface GetLastInspectionError {
  type: typeof GET_LAST_INSPECTION_ERROR
  payload: string | boolean
}

export interface ResetGetLastInspection {
  type: typeof RESET_GET_LAST_INSPECTION
  payload: null
}

export interface State {
  data: GetOneInspectionInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = GetLastInspection | GetLastInspectionSuccess | GetLastInspectionError | ResetGetLastInspection
